import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  template: '{{ content }}',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastMessageWrapperComponent {
  @Input() public content!: string;
}
